import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { expenseDetails } from "../../../core/data/json/expenseDetails";
import Table from "../../../core/common/dataTable/index";
import ReactApexChart from "react-apexcharts";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { formatDate } from "../../../core/utils/FormatData";
import { AppDispatch } from "../../../core/data/redux/store";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllExpenses } from "../../../core/data/redux/payroll/Accounting/expenses/expenseActions";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import {
  fetchAllExpensesReport,
  fetchAllExpensesReportCount,
  fetchAllRequestCount,
} from "../../../core/data/redux/reports/expenses_report/expenses.Action";
import {
  exportToCSV,
  exportToExcel,
} from "../../../core/common/GlobalFunctions/exportTableData";


interface PFReportProps {
  showOnlyTable?: boolean;
}
const PF_report: React.FC<PFReportProps> = ({ showOnlyTable}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { records } = useSelector((state: any) => state.accounting.expenses);
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [selectedSort, setSelectedSort] = useState<any>("");
  const [tableKey, setTableKey] = useState(0);
  const [selectedYear, setSelectedYear] = useState("2025");
  const [chartdata, setchartdata] = useState<any[]>([]);
  const [count, setcount] = useState<any>("");
  const [request, setrequest] = useState<any>([]);

  useEffect(() => {
    dispatch(fetchAllExpenses());
    dispatch(fetchAllExpensesReport(selectedYear)).then((res) => {
      setchartdata(res.payload.data);
    });
    dispatch(fetchAllExpensesReportCount()).then((res) => {
      setcount(res.payload.data);
    });
    dispatch(fetchAllRequestCount()).then((res) => {
      console.log(res.payload.data);
      setrequest(res.payload.data);
    });
  }, [dispatch]);

  const data = records ? records : [];

  function filterExpenseData(data: any[]) {
  return data.map(expense => ({
    expenseName: expense.expense_name || "N/A",
    paymentMethod: expense.payment_method || "N/A",
    requestStatus: expense.requestStatus || "N/A",
    paymentStatus: expense.paymentStatus || "N/A",
    expenseDate: new Date(expense.expense_date).toLocaleDateString(), // format to readable date
    amount: expense.amount || "0.00"
  }));
}

const data2 = filterExpenseData(data)

  const filteredData = useMemo(() => {
    return filterData(data || [], {}, "CreatedAt", "CreatedAt", selectedSort);
  }, [dispatch, records, selectedSort, selectedYear]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [selectedStatus, selectedSort, records, selectedYear]);

  const columns = [
    {
      title: "Reimbursement Name",
      dataIndex: "expense_name",
      sorter: (a: any, b: any) => a.expense_name.length - b.expense_name.length,
    },
    {
      title: "Date",
      dataIndex: "expense_date",
      render: (text: string) => formatDate(text),
      sorter: (a: any, b: any) => a.expense_date.length - b.expense_date.length,
    },
    {
      title: "Payment Method",
      dataIndex: "payment_method",
      sorter: (a: any, b: any) =>
        a.payment_method.length - b.payment_method.length,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (a: any, b: any) => a.amount.length - b.amount.length,
    },
    {
      title: "Request Status",
      dataIndex: "requestStatus",
      sorter: (a: any, b: any) =>
        a.requestStatus.length - b.requestStatus.length,
      render: (status: string) => {
        let color = "";
        switch (status) {
          case "Approved":
            color = "green";
            break;
          case "Rejected":
            color = "red";
            break;
          case "Pending":
            color = "orange";
            break;
          default:
            color = "gray";
        }
        return <span style={{ color, fontWeight: 600 }}>{status}</span>;
      },
    },
    {
      title: "Payment Status ",
      dataIndex: "paymentStatus",
      render: (text: string, record: any) => (
        <span
          className={`badge ${
            text === "Paid" ? "badge-success" : "badge-danger"
          } d-inline-flex align-items-center badge-xs`}
        >
          <i className="ti ti-point-filled me-1" />
          {text}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string, record: any) => (
        <span
          className={`badge ${
            text === "active" ? "badge-success" : "badge-danger"
          } d-inline-flex align-items-center badge-xs`}
        >
          <i className="ti ti-point-filled me-1" />
          {text}
        </span>
      ),
    },
  ];

  useEffect(() => {
    const expensePerMonth = new Array(12).fill(0);

    if (chartdata && chartdata.length > 0) {
      chartdata.forEach(({ month, total_amount }: any) => {
        expensePerMonth[month - 1] = parseFloat(total_amount);
      });
    }

    setexpensechart((prev: any) => ({
      ...prev,
      series: [
        {
          ...prev.series[0],
          data: expensePerMonth,
        },
      ],
    }));
  }, [chartdata , dispatch]);

  useEffect(() => {
    if (selectedYear) {
      dispatch(fetchAllExpensesReport(selectedYear)).then((res) => {
        setchartdata(res.payload.data);
      });
    }
  }, [selectedYear]);

  const handleYearSelect = (year: any) => {
    setSelectedYear(year);
  };

  useEffect(() => {
    if (request && request.length > 0) {
      const { pending_count, approved_count, rejected_count }: any =
        request[0] || {};

      setpaymentreport((prev: any) => ({
        ...prev,
        series: [pending_count , approved_count , rejected_count ],
      }));
    }
  }, [request, dispatch ]);

  //New Chart
  const [expensechart, setexpensechart] = useState<any>({
    series: [
      {
        name: "Expenses",
        data: new Array(12).fill(0),
      },
    ],
    chart: {
      height: 190,
      type: "area",
      zoom: {
        enabled: false,
      },
    },
    colors: ["#FF9F43"],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    title: {
      text: "",
      align: "left",
    },
    // grid: {
    //   row: {
    //     colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
    //     opacity: 0.5
    //   },
    // },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yaxis: {
      min: 0,
      max: 100000,
      tickAmount: 5,
      labels: {
        offsetX: -15,
        formatter: (val: number) => {
          return val / 1 + "K";
        },
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
    },
  });

  const [paymentreport, setpaymentreport] = useState<any>({
    series: [],
    chart: {
      type: "donut",
    },
    colors: ["#0DCAF0", "#FD3995", "#AB47BC"],
    labels: ["Pending", "Approved", "Rejected"],
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 270,
        stroke: {
          show: true,
          width: 10,
          colors: ["#FFFFFF"],
        },
        donut: {
          size: "80%",
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    annotations: {
      position: "front",
      style: {
        fontSize: "24px",
        fontWeight: "bold",
        color: "#000000",
      },
      text: {
        text: "+14%",

        background: {
          enabled: true,
          foreColor: "#FFFFFF",
          border: "#000000",
          borderWidth: 1,
          borderRadius: 2,
          opacity: 0.7,
        },
      },
      x: "50%", // Center horizontally
      y: "50%", // Center vertically
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            show: false, // Also hide legend on smaller screens
          },
        },
      },
    ],
  });
 if (showOnlyTable) {
  return (
   <Table
     key={tableKey}
     dataSource={filteredData}
     columns={columns}
     Selection={true}
   />
  );
}

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">PF Report</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="index.html">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Administration</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    PF Report
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <button
                        onClick={() => exportToCSV(data2, "Reimbursement_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as CSV
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToExcel(data2, "Reimbursement_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="row">
            {/* Total Exponses */}
            <div className="col-xl-6 d-flex">
              <div className="row flex-fill">
                <div className="col-md-6 d-flex">
                  <div className="card flex-fill position-relative">
                    <span className="position-absolute start-0 bottom-0">
                      <ImageWithBasePath
                        src="assets/img/reports-img/total-expense.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    </span>
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <span className="fs-14 fw-normal text-truncate mb-1">
                            Total PF 
                          </span>
                          <h5>{count ? count?.[0].total_amount : 0}</h5>
                        </div>
                        <Link
                          to="#"
                          className="avatar avatar-md avatar-rounded bg-transparent-primary border border-primary"
                        >
                          <span className="text-primary">
                            <i className="ti ti-currency-rupee" />
                          </span>
                        </Link>
                      </div>
                      {/* <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                <span className="text-success fs-12 d-flex align-items-center me-1">
                                                    <i className="ti ti-arrow-wave-right-up me-1" />
                                                    +20.01%
                                                </span>{" "}
                                                from last week
                                            </p> */}
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-flex">
                  <div className="card flex-fill position-relative">
                    <span className="position-absolute start-0 bottom-0">
                      <ImageWithBasePath
                        src="assets/img/reports-img/approved-expense.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    </span>
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <span className="fs-14 fw-normal text-truncate mb-1">
                            Paid
                          </span>
                          <h5>{count ? count?.[0].paid_amount : 0}</h5>
                        </div>
                        <Link
                          to="#"
                          className="avatar avatar-md avatar-rounded bg-transparent-success border border-success"
                        >
                          <span className="text-success">
                            <i className="ti ti-currency-rupee" />
                          </span>
                        </Link>
                      </div>
                      {/* <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                <span className="text-success fs-12 d-flex align-items-center me-1">
                                                    <i className="ti ti-arrow-wave-right-up me-1" />
                                                    +17.01%
                                                </span>{" "}
                                                from last week
                                            </p> */}
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-flex">
                  <div className="card flex-fill position-relative">
                    <span className="position-absolute start-0 bottom-0">
                      <ImageWithBasePath
                        src="assets/img/reports-img/pending-expense.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    </span>
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <span className="fs-14 fw-normal text-truncate mb-1">
                            Unpaid
                          </span>
                          <h5>{count ? count?.[0].unpaid_amount : 0}</h5>
                        </div>
                        <Link
                          to="#"
                          className="avatar avatar-md avatar-rounded bg-transparent-skyblue border border-skyblue"
                        >
                          <span className="text-skyblue">
                            <i className="ti ti-currency-rupee" />
                          </span>
                        </Link>
                      </div>
                      {/* <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                <span className="text-success fs-12 d-flex align-items-center me-1">
                                                    <i className="ti ti-arrow-wave-right-up me-1" />
                                                    +10.13%
                                                </span>{" "}
                                                from last week
                                            </p> */}
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-flex">
                  <div className="card flex-fill position-relative">
                    <span className="position-absolute start-0 bottom-0">
                      <ImageWithBasePath
                        src="assets/img/reports-img/reject-expense.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    </span>
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <span className="fs-14 fw-normal text-truncate mb-1">
                            Pending
                          </span>
                          <h5>{count ? count?.[0].pending_count : 0}</h5>
                        </div>
                        <Link
                          to="#"
                          className="avatar avatar-md avatar-rounded bg-transparent-danger border border-danger"
                        >
                          <span className="text-danger">
                            <i className="ti ti-currency-rupee" />
                          </span>
                        </Link>
                      </div>
                      {/* <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                <span className="text-danger fs-12 d-flex align-items-center me-1">
                                                    <i className="ti ti-arrow-wave-right-up me-1" />
                                                    -10.17%
                                                </span>{" "}
                                                from last week
                                            </p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Total Exponses */}
            {/* Total Exponses */}
            <div className="col-xl-6 d-flex">
              <div className="card flex-fill">
                <div className="card-header border-0 pb-0">
                  <div className="d-flex flex-wrap justify-content-between align-items-center">
                    <div className="d-flex align-items-center ">
                      <span className="me-2">
                        <i className="ti ti-chart-area-line text-danger" />
                      </span>
                      <h5>PF</h5>
                    </div>
                    <div className="dropdown">
                      <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm fs-12 btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        {selectedYear}
                      </Link>
                      <ul className="dropdown-menu  dropdown-menu-end p-2">
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2025")}
                          >
                            2025
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2024")}
                          >
                            2024
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2023")}
                          >
                            2023
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-body py-0">
                  <ReactApexChart
                    id="expense-analysis"
                    options={expensechart}
                    series={expensechart.series}
                    type="bar"
                    height={193}
                  />
                </div>
              </div>
            </div>
            {/* /Total Exponses */}
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>PF List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  {/* <div className="input-icon-end position-relative">
                                        <PredefinedDateRanges />
                                        <span className="input-icon-addon">
                                            <i className="ti ti-chevron-down" />
                                        </span>
                                    </div> */}
                </div>

                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort
                      ? `Sort By : ${selectedSort}`
                      : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Recently Added")}
                        className="dropdown-item rounded-1"
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Ascending")}
                        className="dropdown-item rounded-1"
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Descending")}
                        className="dropdown-item rounded-1"
                      >
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last Month")}
                        className="dropdown-item rounded-1"
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last 7 Days")}
                        className="dropdown-item rounded-1"
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filteredData}
                columns={columns}
                Selection={true}
              />
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default PF_report;
